export default class JdeCustomerInfo {
  readonly jdeCustomerId: string;
  readonly jdeSalesTerr: string;
  readonly jdeSalesArea: string;
  readonly jdeCerRepName: string;
  readonly jdeStateProvince: string;
  readonly agentNum: string;
  readonly customerSegmentation: string;
  readonly jdeCerRepEmail: string;
  readonly jdeCerRepPhoneNumber: string;
  readonly rsmName: string;
  readonly rsmEmail: string;
  readonly rsmPhoneNumber: string;
}
